import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

type H1Props = ComponentProps<'h1'>

export function H1(props: H1Props) {
    return (
        <h1 {...props} className={twMerge(`text-2xl font-semibold`, props.className)} />
    )
}

type H2Props = ComponentProps<'h2'>

export function H2(props: H2Props) {
    return (
        <h2 {...props} className={twMerge(`font-medium`, props.className)} />
    )
}